// Email format check shared by forms. Mirrors the backend rule in
// modules/services.js (getEmailValidationError) — keep the two in sync.
export const EMAIL_RE =
  /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export function isValidEmail(raw) {
  const email = String(raw ?? "").trim();
  return email.length <= 254 && EMAIL_RE.test(email);
}
